import { Environment } from '../constants/environments';

const getIngCookieValue = (name: string) => {
  const { NODE_ENV, ENVIRONMENT } = Environment;
  const keyCookie = String(NODE_ENV) === 'homologation' ? `_${String(ENVIRONMENT)}_` : '_';

  return document.cookie.split(';')
    .map(cookie => cookie.trim())
    .find(cookie => cookie.startsWith(`${`ing_1${keyCookie}${name}`}=`))
    ?.split('=')[1];

};

export default getIngCookieValue;
